module.exports = __webpack_public_path__ + "static/media/fintechnews.399399a7.png";